import { useAuthentication } from '@features/authentication';
import { useBaseDelivery } from '@features/delivery';
import { useRecentEmails } from '@features/delivery/hooks/useRecentEmails';
import { useCallback } from 'react';
import { SendableItem, SendDeliveryItem, SendPayload } from '../types';
import { useSendAction } from './useSendAction';

export const useSendModal = () => {
    const { email: requestorEmail } = useAuthentication();
    const { executeSend } = useSendAction();
    const { recentEmails, addEmailsToHistory } = useRecentEmails();

    const { openModal, deliveryState, deliveryActions } = useBaseDelivery<
        SendDeliveryItem,
        SendPayload
    >({
        apiAction: async (items, payload) => {
            return await executeSend({
                items,
                subject: payload.subject,
                recipients: payload.recipients,
                ccEmails: payload.ccEmails,
                requestorEmail,
            });
        },
        onSuccess: (payload) => {
            const emailsToSave = [...payload.recipients, ...payload.ccEmails];
            if (emailsToSave.length > 0) {
                addEmailsToHistory(emailsToSave);
            }
        },
    });

    const openSend = useCallback(
        (items: SendableItem[]) => {
            const mappedItems: SendDeliveryItem[] = items.map((item) => ({
                ...item,
                isValid: true,
            }));
            openModal(mappedItems);
        },
        [openModal],
    );

    return {
        openSend,
        dialogProps: {
            ...deliveryState,
            ...deliveryActions,
            onOpenChange: deliveryActions.setIsOpen,
            suggestedEmails: recentEmails,
        },
    };
};
